// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2YVgD","header":"ReportDetails_header__1wEau","title":"ReportDetails_title__3wZ7p","left":"ReportDetails_left__13Djc"};